export default {
  sections: {
    address: 'Osoite',
    legal_address: 'Rekisteröintiosoite',
    invoice_address: 'Laskutusosoite',
  },
  form: {
    display_name: {
      label: 'Yleisnimi',
      placeholder: 'Anna yrityksen yleisnimi',
    },
    legal_name: {
      label: 'Virallinen nimi',
      placeholder: 'Anna virallinen nimi',
      tooltip: 'Rekisteröintinimi. Näkyy maksuraporteissa, sopimuksessa jne.',
    },
    timezone: {
      label: 'Aikavyöhyke',
    },
    has_dedicated_invoice_address: {
      label: 'Eri laskutustiedot',
    },
  },
  buttons: {
    next: 'Seuraava',
  },
};
